import makeFormRequest from "../../../../helpers/form-request.js";
import ServerResponse from "../../../../helpers/render-server-response.js";
import Request from "../../../../helpers/request.js";
import APP_COMPONENTS from "../components/index.js";
export default {
    execute: async (data) => {
        const { index, id, form, submitBtn } = data;
        const fileURL = APP_COMPONENTS.fileForms.getURL(index);
        if (!fileURL) {
            APP_COMPONENTS.fileError.show('INCOMPLETE', 'Please upload an image before submitting.');
            return;
        }
        const payload = {
            id,
            type: form.eventtype.value.trim(),
            desc: form.description.value.trim(),
            image: fileURL,
            video: form.videolink.value.trim() || null,
            orderIndex: index,
            ensemble: {
                2: {
                    price: Number(form.two.value.trim()),
                    video: form.videotwo.value.trim() || null
                },
                3: {
                    price: Number(form.three.value.trim()),
                    video: form.videothree.value.trim() || null
                },
                4: {
                    price: Number(form.four.value.trim()),
                    video: form.videofour.value.trim() || null
                },
                5: {
                    price: Number(form.five.value.trim()),
                    video: form.videofive.value.trim() || null
                },
                6: {
                    price: Number(form.six.value.trim()),
                    video: form.videosix.value.trim() || null
                },
                7: {
                    price: Number(form.seven.value.trim()),
                    video: form.videoseven.value.trim() || null
                }
            }
        };
        const formRequest = makeFormRequest({ form, submitBtn });
        const response = await Request.post('/events/update', payload);
        formRequest.afterResponse(false);
        if (response.success) {
            ServerResponse.show({
                resp: response,
                respTitle: 'SUCCESS',
                respText: `Event updated successfully.`
            });
            APP_COMPONENTS.fileForms.update(index, form, id);
            return;
        }
        ServerResponse.show({
            resp: response,
            respTitle: 'ERROR',
            respText: response.error
        });
    }
};
